














import { Component, Vue } from "vue-property-decorator";
const auth = namespace("Auth");
import User from "@/model/user";
import { namespace } from "vuex-class";
import store from "@/store";

@Component({
  name: "Error",
})
export default class Error extends Vue {
  @auth.Getter
  getUserLogging!: User;

  public redirectLogin() {
    this.getUserLogging === null
      ? store.dispatch("Auth/logout")
      : this.$router.push({ name: "login" });
  }
}
